var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 16V19.2267C37.333 21.3333 35.9997 22.6667 33.893 22.6667H29.333V13.3467C29.333 11.8667 30.5463 10.6533 32.0263 10.6667C33.4797 10.68 34.813 11.2667 35.773 12.2267C36.733 13.2 37.333 14.5333 37.333 16Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 17.3334V36C10.667 37.1067 11.9203 37.7334 12.8003 37.0667L15.0803 35.36C15.6137 34.96 16.3603 35.0134 16.8403 35.4934L19.0537 37.72C19.5737 38.24 20.427 38.24 20.947 37.72L23.187 35.48C23.6537 35.0134 24.4003 34.96 24.9203 35.36L27.2003 37.0667C28.0803 37.72 29.3337 37.0934 29.3337 36V13.3334C29.3337 11.8667 30.5337 10.6667 32.0003 10.6667H17.3337H16.0003C12.0003 10.6667 10.667 13.0534 10.667 16V17.3334Z",
    fill: "#F4633A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2396 24.1067C22.5063 24.1067 21.9062 24.7067 21.9062 25.44C21.9062 26.1734 22.5063 26.7734 23.2396 26.7734C23.9729 26.7734 24.5729 26.1734 24.5729 25.44C24.5729 24.7067 23.9729 24.1067 23.2396 24.1067Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7601 21.3733C17.5068 21.3733 18.0934 20.7733 18.0934 20.04C18.0934 19.3067 17.4934 18.7067 16.7601 18.7067C16.0268 18.7067 15.4268 19.3067 15.4268 20.04C15.4268 20.7733 16.0268 21.3733 16.7601 21.3733Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3466 18.32C23.9599 17.9334 23.3199 17.9334 22.9333 18.32L15.6533 25.6C15.2666 25.9867 15.2666 26.6267 15.6533 27.0134C15.8533 27.2134 16.1066 27.3067 16.3599 27.3067C16.6133 27.3067 16.8666 27.2134 17.0666 27.0134L24.3466 19.7334C24.7333 19.3467 24.7333 18.7067 24.3466 18.32Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheap);
export default __webpack_public_path__ + "static/media/cheap.795ff2c950d4b71decc022548b66dda7.svg";
export { ForwardRef as ReactComponent };